Postlogin = (function (self) {
    self.CareerClusterSearch = {};
    const me = self.CareerClusterSearch;

    let lastSearchTerm = '';

    me.init = function () {
        $('#career-central-search').on('click', '#clear-search', () => {
            // move cluster list back
            $('#career-central-search > input').val('');
            $('.cluster .careers .career').removeClass('hidden');
            $('#clear-search').removeClass('shown');
            $('#magnifying-glass').addClass('shown');
        });

        $('#career-central-search > input').on(
            'keyup',
            _.debounce(() => {
                const searchTerm = $('#career-central-search > input').val();

                if (searchTerm === lastSearchTerm) {
                    return;
                }
                lastSearchTerm = searchTerm;

                if (searchTerm === '') {
                    $('.cluster .careers .career').removeClass('hidden');
                    $('#clear-search').removeClass('shown');
                    $('#magnifying-glass').addClass('shown');
                } else {
                    $('#clear-search').addClass('shown');
                    $('#magnifying-glass').removeClass('shown');
                }
            }, 300),
        ); // < try 300 rather than 100
    };

    return self;
}(Postlogin || {}));
